let _ = t => t,
  _t;
import { PureComponent } from 'react';
import { css } from 'styled-components';
import { Flex } from 'foundations-components/components/Flex';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const tlmSidebarDynamicWidthStyles = css(["min-width:260px;max-width:376px;width:21vw;@media (min-width:1920px){max-width:420px;}"]);
export const StyledWrapper = styledWithTheme.div(_t || (_t = _`
  /* stylelint-disable comment-empty-line-before */
  display: flex;
  height: 100%;
  background-color: ${0};
  flex-basis: 100%;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 0;

  ${0}
`), ({
  theme
}) => theme.color['fill-surface-default'], tlmSidebarDynamicWidthStyles);
export default class ThreadListMemberSidebarFrame extends PureComponent {
  render() {
    const {
      children
    } = this.props;
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(StyledWrapper, {
        children: /*#__PURE__*/_jsx(Flex, {
          backgroundColor: "fill-surface-default",
          "data-test-id": "selenium-test-marker-thread-list",
          flexBasis: "100%",
          flexDirection: "column",
          flexGrow: "1",
          flexShrink: "0",
          inlineSize: "100%",
          children: /*#__PURE__*/_jsx(Flex, {
            borderInlineEndColor: "border-core-subtle",
            borderInlineEndWidth: "100",
            borderInlineEndStyle: "solid",
            flexBasis: "100%",
            flexDirection: "column",
            flexGrow: "1",
            flexShrink: "0",
            overflowX: "hidden",
            children: children
          })
        })
      })
    );
  }
}
ThreadListMemberSidebarFrame.displayName = 'ThreadListMemberSidebarFrame';